var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33397 5.33301H17.334C17.6876 5.33301 18.0267 5.47348 18.2768 5.72353C18.5268 5.97358 18.6673 6.31272 18.6673 6.66634V14.6663C18.6673 15.02 18.5268 15.3591 18.2768 15.6091C18.0267 15.8592 17.6876 15.9997 17.334 15.9997H9.33397C8.98035 15.9997 8.64121 15.8592 8.39116 15.6091C8.14111 15.3591 8.00064 15.02 8.00064 14.6663V6.66634C8.00064 6.31272 8.14111 5.97358 8.39116 5.72353C8.64121 5.47348 8.98035 5.33301 9.33397 5.33301ZM9.33397 14.6663H17.334V6.66634H9.33397V14.6663Z",
    fill: "#0074AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 8.66634C6.66732 8.29815 6.36884 7.99967 6.00065 7.99967C5.63246 7.99967 5.33398 8.29815 5.33398 8.66634V17.333C5.33398 18.0694 5.93094 18.6663 6.66732 18.6663H15.334C15.7022 18.6663 16.0007 18.3679 16.0007 17.9997C16.0007 17.6315 15.7022 17.333 15.334 17.333H6.66732V8.66634Z",
    fill: "#0074AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardOutline);
export default __webpack_public_path__ + "static/media/clipboard-outline.e4ec2d5e924a85a975c968db650cd7b2.svg";
export { ForwardRef as ReactComponent };